import React from 'react'
import PropTypes from 'prop-types'
import { useUpsells } from './UpsellsProvider'
import { MenuItemCard } from '../MenuItemCard/MenuItemCard'
import Slider from 'react-slick'

import AddToCart from '../../assets/add-to-cart.svg'
import { imgInPreprod } from '../../utils/img-url'

import './CartUpsells.css'

const AddToCartAdornment = ({ imageUrl }) => {
  if (!imageUrl) {
    return (
      <div styleName='addToCartAdornment'>
        <AddToCart />
      </div>
    )
  }

  return (
    <div
      style={{ backgroundImage: `url(${imageUrl})` }}
      styleName='image'
    />
  )
}

AddToCartAdornment.propTypes = {
  imageUrl: PropTypes.string
}

export const CartUpsells = () => {
  const { upsells } = useUpsells()

  return upsells.length > 0 && (
    <div styleName='container'>
      <div styleName='recommended'>Our suggestions for you</div>
      <ul styleName='passiveItemsList'>
        <Slider
          infinite
          speed={500}
          slidesToScroll={1}
          slidesToShow={1}
        >
          {upsells.slice(0, 5).map((item) => {
            return (
              <MenuItemCard
                key={item.guid}
                item={item}
                dataTestid='promote-item-cart-card'
                endAdornment={<AddToCartAdornment imageUrl={imgInPreprod(item.imageUrl)} />}
              />
            )
          })}
        </Slider>
      </ul>
    </div>
  )
}
